module.exports = __webpack_public_path__ + "static/media/add-bank-account-details.d08a12f9.svg";